import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StepperService {
  private readonly nextStep = 'next';
  private readonly previousStep = 'previous';

  private navigationBehaviorSubject = new BehaviorSubject<number>(0);

  navigationBehaviorSubject$ = this.navigationBehaviorSubject.asObservable();

  emitNext(nextIndex: number) {
    this.navigationBehaviorSubject.next(nextIndex);
  }

  emitPrevious(previousIndex: number) {
    this.navigationBehaviorSubject.next(previousIndex);
  }
}
